import { Component, OnInit } from '@angular/core';
import { School } from './org.school';
import { OrgService } from '../_services/org.service';
import { Subscription } from 'rxjs';
@Component({
	selector: 'dropdown-school',
	templateUrl: './dropdown-school.component.html',
})
export class DropdownSchoolComponent implements OnInit {
	schools: School[];
	selectedSchool: School;
	subscriptions: Subscription[] = [];
	constructor(public orgService: OrgService) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.orgService.schools$.subscribe((data: any) => {
				this.schools = data;
			}),
		);

		this.subscriptions.push(
			this.orgService.selectedSchool$.subscribe((data: any) => {
				this.selectedSchool = data;
			}),
		);
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
